import { ClientConfig } from '../types/profile';

export const demoClientConfig: ClientConfig = {
  id: 'client-demo-002',
  slug: 'sarah-consulting',
  profileUrl: 'https://demo.smartprofile.io/sarah',
  defaultLocale: 'en',
  supportedLocales: ['en', 'ar'],
  identity: {
    name: {
      en: 'Dr. Sarah Al-Mansoor',
      ar: 'د. سارة المنصور',
    },
    tagline: {
      en: 'Executive Strategy & Health Systems Consultant',
      ar: 'مستشارة استراتيجيات الأنظمة الصحية وتطوير الأعمال',
    },
    description: {
      en: 'Advising regional healthcare organizations on digital health adoption, hospital modernization, and health-tech investments.',
      ar: 'تقديم الاستشارات للجهات الصحية الإقليمية في التحول الصحي الرقمي وتطوير المستشفيات والاستثمار التقني.',
    },
    logoUrl: '/assets/demo-logo.svg',
    avatarUrl: '/assets/demo-logo.svg',
    badge: {
      en: 'Board Certified Consultant',
      ar: 'مستشار معتمد',
    },
    verified: true,
  },
  branding: {
    primaryColor: '#059669',
    primaryGlowColor: '#34d399',
    accentGoldColor: '#d97706',
    accentGreenColor: '#10b981',
    accentPurpleColor: '#6366f1',
    backgroundColor: '#061a14',
    cardBackgroundColor: 'rgba(6, 40, 32, 0.85)',
    borderColor: 'rgba(52, 211, 153, 0.25)',
    textColor: '#f0fdf4',
    mutedTextColor: '#a7f3d0',
    borderRadius: '20px',
    logoStyle: 'glow',
    logoMotion: 'float',
    poweredByUrl: 'https://profile.jetown.net/smart-profile',
  },
  metadata: {
    title: {
      ar: 'د. سارة المنصور | استشارات الأعمال',
      en: 'Dr. Sarah Al-Mansoor | Management Consultant',
    },
    description: {
      ar: 'مستشارة استراتيجية للأعمال والتحول الرقمي المؤسسي.',
      en: 'Enterprise Business & Strategy Consultant.',
    },
    favicon: '/assets/demo-logo.svg',
    canonicalUrl: 'https://profile.jetown.net',
  },
  qr: {
    enabled: true,
    branded: true,
    logo: true,
    foreground: '#059669',
    background: '#ffffff',
    accent: '#34d399',
  },
  contacts: {
    phone: '+971501234567',
    whatsapp: '+971501234567',
    whatsappGreeting: {
      en: 'Hello Dr. Sarah, I would like to schedule a strategy consultation',
      ar: 'مرحباً د. سارة، أود حجز جلسة استشارية استراتيجية',
    },
    email: 'sarah@almansoor-consulting.com',
    website: 'https://almansoor-consulting.com',
    address: {
      en: 'Dubai Healthcare City, UAE',
      ar: 'مدينة دبي الطبية، الإمارات العربية المتحدة',
    },
  },
  socials: [
    {
      id: 'li',
      platform: 'linkedin',
      url: 'https://linkedin.com/in/sarah-almansoor',
      label: { en: 'LinkedIn', ar: 'لينكد إن' },
    },
    {
      id: 'x',
      platform: 'twitter',
      url: 'https://x.com/sarah_almansoor',
      label: { en: 'X / Twitter', ar: 'تويتر' },
    },
  ],
  services: [
    {
      id: 'health-strategy',
      title: {
        en: 'Health Systems Modernization',
        ar: 'تحديث الأنظمة الصحية',
      },
      description: {
        en: 'Digital roadmap design for hospital networks and medical centers.',
        ar: 'تصميم خارطة طريق التحول الرقمي لشبكات المستشفيات والمراكز الطبية.',
      },
      badge: { en: 'Advisory', ar: 'استشارات' },
      highlighted: true,
    },
    {
      id: 'healthtech-evaluation',
      title: {
        en: 'HealthTech Due Diligence',
        ar: 'تقييم الاستثمارات والتقنيات الطبية',
      },
      description: {
        en: 'Clinical and operational assessment of medical AI and software vendors.',
        ar: 'تقييم سريري وتشغيلي لتقنيات الذكاء الاصطناعي والبرمجيات الطبية.',
      },
      badge: { en: 'Due Diligence', ar: 'تدقيق' },
    },
  ],
  features: {
    vCardDownload: true,
    qrModal: true,
    shareProfile: true,
    contactForm: true,
    aiAssistant: false,
    servicesShowcase: true,
    socialGrid: true,
    virtualTour: true,
  },
  virtualTour: {
    enabled: true,
    url: 'https://demo-clinic.example.com/virtual-tour-360',
    label: {
      en: 'Executive Clinic 360° Tour',
      ar: 'جولة العيادة الاستشارية 360°',
    },
    description: {
      en: 'Explore the modern executive healthcare consulting suites in 360° virtual reality.',
      ar: 'استكشف أجنحة الاستشارات الصحية التنفيذية بتجربة الواقع الافتراضي 360°.',
    },
    badge: {
      en: '360° Tour',
      ar: 'تجربة 360°',
    },
  },
  footerText: {
    en: '© 2026 Dr. Sarah Al-Mansoor Advisory. All rights reserved.',
    ar: '© 2026 مكتب د. سارة المنصور للاستشارات. جميع الحقوق محفوظة.',
  },
  regionsText: {
    en: 'Dubai • Riyadh • Abu Dhabi',
    ar: 'دبي • الرياض • أبوظبي',
  },
};
